import KeyValueListDisplay from '@/components/KeyValueDisplay';
import type { DeliveryDetailPickupInformation } from '@/types/deliveryDetail.types';
import { convertISODateToMMDDYYYY, convertISOToTime } from '@/lib/utils';

export const PickupInformationContent = ({ data }: { data: DeliveryDetailPickupInformation | undefined }) => {
  if (!data) return null;

  const pickupDetails = [
    { label: "Person/Entity's Name", value: data.pickupName },
    { label: 'Address', value: data.pickupAddress },
    {
      label: 'Pickup Date and Time',
      value: `${convertISODateToMMDDYYYY(data.pickupDateTime)} ${convertISOToTime(data.pickupDateTime)}`,
    },
    { label: 'Printing', value: data.printing ?? '-' },
    { label: 'Type of Pickup', value: data.pickupType },
    { label: 'Number of Items', value: data.numberOfItems.toString() },
    { label: 'Time Ready', value: data.timeReady ?? '-' },
    { label: 'Assigned Pickup Driver', value: data.pickupDriverName ?? '-' },
    { label: "Driver's Phone Number", value: data.pickupDriverPhone ?? '-' },
    { label: 'Instructions', value: data.pickupInstructions ?? '-' },
  ];

  return (
    <div className="flex flex-col gap-4 w-full px-6 py-4">
      <div className="flex flex-col gap-2 w-full text-sm">
        <KeyValueListDisplay data={pickupDetails} />
      </div>
    </div>
  );
};
